<template>
  <div class="spinner-wrapper">
    <div class="neo-spinner">
      <div class="orbit" />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
.spinner-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: grid;
  place-items: center;
  z-index: 9999;
  backdrop-filter: blur(3px);
}

.neo-spinner {
  --size: 100px;
  --speed: 1.2s;
  --color-primary: #0058aa;
  --color-secondary: #b9ddf9;

  width: var(--size);
  height: var(--size);
  position: relative;
}

.orbit {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: orbit var(--speed) linear infinite;
  border: 5px solid;
  border-color: var(--color-primary) transparent var(--color-secondary) transparent;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    top: -10px;
  }

  &::before {
    left: 10px;
  }

  &::after {
    right: 10px;
  }
}

@keyframes orbit {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .orbit {
    animation-duration: calc(var(--speed) * 2);
  }
}
</style>
